/* Quick Add Modal – Safari/iPad fix’li tam sürüm */
if (!customElements.get('quick-add-modal')) {
  customElements.define('quick-add-modal', class QuickAddModal extends ModalDialog {
    constructor() {
      super();
      this.modalContent = this.querySelector('[id^="QuickAddInfo-"]');
    }

    /* Arka plan scroll kilidi */
    lockScroll() {
      document.documentElement.classList.add('qb-lock');
      document.body.classList.add('qb-lock');
    }
    unlockScroll() {
      document.documentElement.classList.remove('qb-lock');
      document.body.classList.remove('qb-lock');
    }

    /* Modal içindeki ürün şablonunu geniş ve güvenli ölçülere getir */
    applyPanelSizing() {
      const root = this.modalContent;
      if (root) {
        root.style.boxSizing = 'border-box';
        root.style.minWidth = '0';
        root.style.minHeight = '0';
        root.style.maxWidth = 'min(1200px, 98vw)';  // geniş panel
        root.style.width    = 'min(1200px, 98vw)';
        root.style.maxHeight = '90dvh';
        root.style.overflow  = 'auto';
      }

      const panel = this.modalContent.querySelector('.main-product_info') || this.modalContent.firstElementChild;
      if (panel) {
        panel.style.boxSizing = 'border-box';
        panel.style.minWidth = '0';
        panel.style.minHeight = '0';
        panel.style.maxWidth = 'min(1500px, 98vw)';
        panel.style.width    = 'min(1500px, 98vw)';
        panel.style.maxHeight = '90dvh';
        panel.style.overflow  = 'auto';
      }
    }

    hide(preventFocus = false) {
      const cartNotification = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      if (cartNotification) cartNotification.setActiveElement(this.openedBy);
      this.modalContent.innerHTML = '';

      if (preventFocus) this.openedBy = null;

      super.hide();
      this.unlockScroll();
    }

    show(opener) {
      /* PORTAL: modal’ı body altına taşı (iOS/Safari fixed/transform sorunlarını çözer) */
      if (this.parentElement !== document.body) {
        document.body.appendChild(this);
      }

      opener.setAttribute('aria-disabled', true);
      opener.classList.add('loading');

      const dtLoader = document.createElement('div');
      dtLoader.className = 'dT_loading';
      dtLoader.innerHTML = `<div class="loading"></div>`;

      setTimeout(() => {
        $('.quick-add-modal[open]').find('.main-product_info').addClass('quick-add-modal-in-progress');
      }, 100);

      setTimeout(() => {
        $('.main-product_info').removeClass('quick-add-modal-in-progress');
      }, 200);

      const spinner = opener.querySelector('.loading-overlay__spinner');
      if (spinner) spinner.classList.remove('hidden');

      fetch(opener.getAttribute('data-product-url'))
        .then((response) => response.text())
        .then((responseText) => {
          const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
          this.productElement = responseHTML.querySelector('section[id^="MainProduct-"]');

          this.preventDuplicatedIDs();
          this.removeDOMElements();
          this.setInnerHTML(this.modalContent, this.productElement.innerHTML);

          /* Safari/iPad ölçü fixleri */
          this.applyPanelSizing();

          if (window.Shopify && Shopify.PaymentButton) Shopify.PaymentButton.init();
          if (window.ProductModel) window.ProductModel.loadShopifyXR();

          this.removeGalleryListSemantic();
          this.preventVariantURLSwitching();

          /* Ölçü/portal sonrasında aç */
          super.show(opener);
          this.lockScroll();
        })
        .finally(() => {
          opener.removeAttribute('aria-disabled');
          opener.classList.remove('loading');
          const sp = opener.querySelector('.loading-overlay__spinner');
          if (sp) sp.classList.add('hidden');
        });
    }

    setInnerHTML(element, html) {
      element.innerHTML = html;

      // script’leri yeniden enjekte et (innerHTML onları çalıştırmaz)
      element.querySelectorAll('script').forEach(oldScriptTag => {
        const newScriptTag = document.createElement('script');
        Array.from(oldScriptTag.attributes).forEach(attr => {
          newScriptTag.setAttribute(attr.name, attr.value);
        });
        newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
        oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
      });
    }

    preventVariantURLSwitching() {
      const variantPicker = this.modalContent.querySelector('variant-radios,variant-selects');
      if (!variantPicker) return;
      variantPicker.setAttribute('data-update-url', 'false');

      // Tema özel renk swatch örneği (jquery varsa)
      if (window.$) {
        $('input:radio[name="Color"]').on('click', function () {
          $('input:radio[name="Color"]').next('.swatch-element').removeClass('clicked');
          $(this).next('.swatch-element').addClass('clicked');
        });
      }
    }

    removeDOMElements() {
      const pickupAvailability = this.productElement.querySelector('pickup-availability');
      if (pickupAvailability) pickupAvailability.remove();

      const productModal = this.productElement.querySelector('product-modal');
      if (productModal) productModal.remove();

      const productEnquiry = this.productElement.querySelector('enquiryPopUp');
      if (productEnquiry) productEnquiry.remove();

      const modalDialog = this.productElement.querySelectorAll('modal-dialog');
      if (modalDialog) modalDialog.forEach(m => m.remove());
    }

    preventDuplicatedIDs() {
      const sectionId = this.productElement.dataset.section;
      this.productElement.innerHTML =
        this.productElement.innerHTML.replaceAll(sectionId, `quickadd-${sectionId}`);
      this.productElement.querySelectorAll('variant-selects, variant-radios').forEach(vs => {
        vs.dataset.originalSection = sectionId;
      });
    }

    removeGalleryListSemantic() {
      const galleryList = this.modalContent.querySelector('[id^="Slider-Gallery"]');
      if (!galleryList) return;
      galleryList.setAttribute('role', 'presentation');
      galleryList.querySelectorAll('[id^="Slide-"]').forEach(li => li.setAttribute('role', 'presentation'));

      const FBT = this.modalContent.querySelector('[id^="dT_bundleSelector"]');
      if (FBT) FBT.remove();
      const Tabs = this.modalContent.querySelector('[class^="product__info-as-bottom-tabs"]');
      if (Tabs) Tabs.remove();
    }
  });
}
